import { Resource } from '@redge-media/fo-js-sdk';
import Serial from './serial';

const Series = Resource.extend({
  endpoint: '/products/vods/serials',

  constructor: function Series() {
    Resource.call(this);

    this.recordClass = Serial;
    this.meta = {};
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);
    this.meta = data.meta || {};
    return data.items || data;
  },

  getPath(method, props = {}) {
    let path = Resource.prototype.getPath.call(this, method, props);
    if (method === 'fetchAll') {
      path += '/list';
    }

    return path;
  },
});

export default Series;
